export enum Patterns {
    URL='^https?://[^\\s]+$',
    NUMERIC='[0-9]+',
    ALPHANUMERIC='[A-Z,a-z,0-9]+',
    ALPHANUMERIC_DASH_UNDERSCORE = '^[A-Za-z0-9_-]+$',
    ALPHANUMERICPLUS='[A-Z,a-z,0-9.-]+',
    ALPHANUMERICPLUSSPECIAL='^(?! )[a-zA-Z0-9 !@#$%^&*()_+\/-]{1,50}(?<! )$',
    SCHEMA_FILE='^.*\.(json|xsd|zip)$',
    JSON_FILE='^.*\.(json)$',
    HTML_FILE='^.*\.(html)$',
    XSLT_FILE='^.*\.(xslt)$',
    PHONE='^\\+?(?:[0-9]?){6,14}[0-9]$',
    TEXT_BLOCK_NAME='^[^,]+$'
}
